import { useState, useCallback, useEffect } from "react";
import { getPlaybackSpeed, setPlaybackSpeed as applySpeed } from "@/lib/speak";

// Learner playback-rate control. Persists via `speak.js` (localStorage) so it
// survives reloads and travels with the child across lessons. Any component
// that renders a SpeedPicker just calls the returned setter — it updates the
// shared audio element instantly.
export function usePlaybackSpeed() {
  const [speed, setSpeed] = useState(() => getPlaybackSpeed());
  const change = useCallback((rate) => {
    const s = applySpeed(rate);
    setSpeed(s);
  }, []);
  // Keep local state in sync if another tab/component mutates the value.
  useEffect(() => {
    const on = (e) => { if (e.key === "zl_playback_speed") setSpeed(getPlaybackSpeed()); };
    window.addEventListener("storage", on);
    return () => window.removeEventListener("storage", on);
  }, []);
  return [speed, change];
}
